import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import {
    PolotnoStoreActivePageKeys,
    PolotnoStoreKeys,
    polotnoStorePageDefaults,
    setPageProperty,
    useSetPolotnoState,
} from '@/pages/AdvancedEditor/hooks';
import { ScriptType } from '@d-id/types';
import { NormalizedProjectData } from './useNormalizePolotnoInitialData';

export const useInitNormalizedData = () => {
    const { store } = useAdvancedEditorContext();
    const setVideoName = useSetPolotnoState(PolotnoStoreKeys.creativeVideoName);

    const initNormalizedData = async (normalizedData: NormalizedProjectData, page: Page) => {
        await store.history.transaction(async () => {
            const presenter = normalizedData.presenterId || polotnoStorePageDefaults.selectedPresenter.defaultValue;
            setPageProperty(page, PolotnoStoreActivePageKeys.selectedPresenter)(presenter);

            const driver = normalizedData.driver || polotnoStorePageDefaults.selectedDriver.defaultValue;
            setPageProperty(page, PolotnoStoreActivePageKeys.selectedDriver)(driver);

            const voiceConfig = { ...polotnoStorePageDefaults.ttsVoiceConfig.defaultValue, rate: normalizedData.rate };
            setPageProperty(page, PolotnoStoreActivePageKeys.ttsVoiceConfig)(voiceConfig);

            const text = normalizedData.text || polotnoStorePageDefaults.textInput.defaultValue;
            setPageProperty(page, PolotnoStoreActivePageKeys.textInput)(text);

            const audio = normalizedData.audio;
            if (audio) {
                setPageProperty(page, PolotnoStoreActivePageKeys.uploadedAudio)(audio);
                setPageProperty(page, PolotnoStoreActivePageKeys.selectedScript)(ScriptType.audio);
            }

            const language = normalizedData.language;
            if (language) {
                setPageProperty(page, PolotnoStoreActivePageKeys.ttsSelectedLanguage)(language);

                setPageProperty(page, PolotnoStoreActivePageKeys.ttsSelectedVoice)(normalizedData.voice?.voice || null);
                setPageProperty(page, PolotnoStoreActivePageKeys.ttsIsSelectedDefault)(!!normalizedData.voice?.isSelectedDefault);
            }

            const emotion = normalizedData.emotion;
            if (emotion) {
                setPageProperty(page, PolotnoStoreActivePageKeys.selectedEmotion)(emotion);
            }

            const videoName = normalizedData.videoName;
            if (videoName) {
                setVideoName(videoName);
            }
        });
    };

    return { initNormalizedData };
};
